var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"component-admin-switch",class:{
    'component-admin-switch_wide': _vm.wide,
    'component-admin-switch_disabled': _vm.disabled,
    'component-admin-switch_hollow-inactive': _vm.hollowInactive,
    'component-admin-switch_grey-inactive': _vm.greyInactive,
  },attrs:{"label":_vm.label,"ripple":false,"disabled":_vm.disabled,"inset":"","dense":"","hide-details":""},model:{value:(_vm.currentSwitchValue),callback:function ($$v) {_vm.currentSwitchValue=$$v},expression:"currentSwitchValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }